// extracted by mini-css-extract-plugin
module.exports = {"epro_patient_confirm_invit":"confirmInvit_epro_patient_confirm_invit__2-0cM","invit_info":"confirmInvit_invit_info__2pcp1","btnJoin":"confirmInvit_btnJoin__3XLD5"};